import { useTonConnectUI } from '@tonconnect/ui-react'
import { useCallback } from 'react'

export const useDisconnectWallet = () => {
  const [tonConnectUI] = useTonConnectUI()

  const disconnect = useCallback(() => {
    tonConnectUI.disconnect()
  }, [tonConnectUI])

  return { disconnect }
}
